import { render, staticRenderFns } from "./FishChallengeComponent.vue?vue&type=template&id=708a258e&"
import script from "./FishChallengeComponent.vue?vue&type=script&lang=ts&"
export * from "./FishChallengeComponent.vue?vue&type=script&lang=ts&"
import style0 from "./FishChallengeComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports